import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";

import { useSelector } from "react-redux";

const PlaceOrders = () => {
    const { ordernumber } = useParams();
    const [productPlaceOrder, setProductPlaceOrder] = useState([]);
    const [billPlaceOrder, setBillPlaceOrder] = useState([]);
    const [query, setQuery] = useState("");
    const { apiUrl } = useSelector(state => state.api);

    const listAllOrder = async () => {
        try {
            const response = await axios.get(`${apiUrl}/myaccount/placeorders`, {
                headers: { token: localStorage.getItem('token') }
            })

            //handle data place order from database
            const { getOrderBill, getOrderProduct } = response.data
            const combinedOrderBillProduct = getOrderBill?.map(bill => {
                const filterData = getOrderProduct?.filter(product => {
                    return product.order_number === bill.order_number
                })
                return filterData;
            });
            setProductPlaceOrder(combinedOrderBillProduct)
            setBillPlaceOrder(getOrderBill)
        } catch (err) {
            console.error(err.message);
        }
    };

    useEffect(() => {
        listAllOrder();
    }, [apiUrl])

    const handleSearch = async () => {
        const data = { query };
        try {
            if (!query) {
                listAllOrder();
            }
            const response = await axios.get(`${apiUrl}/myaccount/placeorders/search`, {
                params: data,
                headers: { token: localStorage.getItem('token') }
            });
            //handle data place order from database
            const { getOrderBill, getOrderProduct } = response.data
            const combinedOrderBillProduct = getOrderBill?.map(bill => {
                const filterData = getOrderProduct?.filter(product => {
                    return product.order_number === bill.order_number
                })
                return filterData;
            });

            setProductPlaceOrder(combinedOrderBillProduct)
            setBillPlaceOrder(getOrderBill)
        } catch (err) {
            console.error(err.message);
            console.log(err.response);
            // setStatusSearch(err.response.data)
        }
    };

    const handleKeyDown = (event) => {
        if (event.key === "Enter") {
            handleSearch();
        }
    };

    const handleInputChange = (event) => {
        setQuery(event.target.value);
    };
    // console.log(query);


    useEffect(() => {
        const handleGetOneOrder = async () => {
            // const params = ordernumber;
            try {
                if (ordernumber) {
                    const response = await axios.get(`${apiUrl}/myaccount/placeorders/${ordernumber}`, {
                        headers: { token: localStorage.getItem('token') }
                    });
                    //handle data place order from database
                    const { getOrderBill, getOrderProduct } = response.data
                    const combinedOrderBillProduct = getOrderBill?.map(bill => {
                        const filterData = getOrderProduct?.filter(product => {
                            return product.order_number === bill.order_number
                        })
                        return filterData;
                    });
                    setProductPlaceOrder(combinedOrderBillProduct)
                    setBillPlaceOrder(getOrderBill)
                }
            } catch (err) {
                console.error(err.message);
                console.log(err.response);
                // setStatusSearch(err.response.data)
            }
        };
        handleGetOneOrder()
    }, [apiUrl, ordernumber])


    return (
        <div className="col-md-10 bg-light p-2 ">
            <div className="row d-flex justify-content-center">

                <div class="col-md-10 text-center">

                    <div className="input-group mb-3 ">
                        <input
                            type="text" className="form-control" aria-label="Search" aria-describedby="basic-addon2"
                            placeholder="You are can search by name product or ID order"
                            value={query}
                            onChange={handleInputChange}
                            onKeyDown={handleKeyDown}
                        />
                        <button
                            className="btn btn-outline-secondary" type="button" id="search-button"
                            onClick={handleSearch}
                        >
                            Search
                        </button>
                    </div>
                    {productPlaceOrder?.map((element, ind) => (
                        <>
                            {console.log(element)}
                            <nav class="d-flex justify-content-start align-items-start mt-2 mb-2" style={{ "font-size": "14px" }}
                            >Your order Number:#
                                <Link to={`/myaccount/placeorders/${billPlaceOrder[ind].order_number}`}>{billPlaceOrder[ind].order_number}
                                </Link>-|-{new Date(billPlaceOrder[ind].order_time).toLocaleString().replace(',', '')}
                            </nav >

                            <table class="table">
                                <thead class="table-primary">
                                    <tr>
                                        <th>Product</th>
                                        <th>Quantity</th>
                                        <th>Total</th>

                                    </tr>
                                </thead>
                                <tbody >
                                    {element?.map(item => (
                                        <tr>
                                            <td class="text-start">
                                                <img src={apiUrl + "/" + item.product_img}
                                                    alt={item.product_name}
                                                    style={{ height: "80px", width: " 80px" }} />
                                                {item.product_name}</td>
                                            <td>{item.order_quantity}</td>
                                            <td>{item.product_price}</td>
                                        </tr>
                                    ))}
                                </tbody>
                                <thead class="table-success">
                                    <tr>
                                        <th></th>
                                        <th>Order Total:</th>
                                        <th>${billPlaceOrder[ind].order_bill.toLocaleString('en-US', {
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2,
                                        }).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')}</th>

                                    </tr>
                                </thead>
                            </table>
                        </>
                    ))}

                    {(productPlaceOrder.length <= 0) && <div>No orders yet.</div>}
                    {/* {statusSearch} */}
                </div>
            </div>
        </div>

    )
}
export default PlaceOrders;
